import React, { setGlobal } from 'reactn';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';

import './index.css';
import Root from 'pages/Root';
import { loadState, noOp } from 'meta/util';
import { GlobalState } from 'meta/types';

Sentry.init({
	dsn: 'https://84048fc0f3bd4476a2ae07e0d2dd956f@o427158.ingest.sentry.io/5370845'
});

const discordUser = loadState('discord_user');
const discordToken = loadState('discord_token');

setGlobal({
	authenticated: Boolean(discordToken) && Boolean(discordUser),
	user: discordUser,
	token: discordToken
} as GlobalState).catch(noOp);

ReactDOM.render(<Root />, document.getElementById('root'));
